var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712",
    transform: "translate(1.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    d: "M8.15-.85a9,9,0,0,1,9,9,9,9,0,0,1-9,9,9,9,0,0,1-9-9,9,9,0,0,1,9-9Zm0,16.59A7.59,7.59,0,1,0,.56,8.15,7.6,7.6,0,0,0,8.15,15.74Z",
    transform: "translate(0.85 0.85)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M15.172,13.2a.7.7,0,0,1-.315-.075L11.54,11.463a.705.705,0,0,1-.39-.631V5.855a.705.705,0,0,1,1.41,0V10.4l2.928,1.464a.705.705,0,0,1-.316,1.336Z",
    transform: "translate(-2.855 -1.832)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockHover);
export default __webpack_public_path__ + "static/media/clock-hover.569a6fbec72415fb37604dc05c628d63.svg";
export { ForwardRef as ReactComponent };